import { render } from "./ManagedAccessRestricted.vue?vue&type=template&id=7cfb5ff2&scoped=true"
import script from "./ManagedAccessRestricted.vue?vue&type=script&lang=js"
export * from "./ManagedAccessRestricted.vue?vue&type=script&lang=js"

import "./ManagedAccessRestricted.vue?vue&type=style&index=0&id=7cfb5ff2&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/53/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cfb5ff2"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
